import { IAgreementFilters } from 'src/app/modules/logged/agreements/store/types';

export class SetCurrentTab {
    static readonly type = '[agreement] set current tab';
    constructor(public tab?: 'COMPANY' | 'SUBCONTRACTOR SOLE TRADER' | 'SUBCONTRACTOR COMPANY' | 'SUBCONTRACTOR PARTNERSHIP', public filters?: Partial<IAgreementFilters>) { }
}

export class SetSearchField {
    static readonly type = '[agreement] set search field';
    constructor(public value: string) { }
}

export class SetFiltersBasedOnTab {
    static readonly type = '[agreement] set filters based on tab';
    constructor(public filters?: Partial<IAgreementFilters>) { }
}